import { AllActions } from '../../shared/redux/types';

import * as actions from './actions';

export const filterReducer = (state = false, action: AllActions): boolean => {
    switch (action.type) {
        case actions.displayFiltersAction:
            return true;
        case actions.hideFiltersAction:
            return false;
        default:
            return state;
    }
};
